import React from "react";
import { BOOKING_STATUS } from "utils/constant";
import Badge from "components/common/Badge";
interface BookingStatusProps {
  status:
    | "waiting"
    | "accepted"
    | "done"
    | "user_cancelled"
    | "shop_cancelled"
    | "not_show";
}
const statusLabel = {
  [BOOKING_STATUS.WAITING]: "Đang chờ nhận",
  [BOOKING_STATUS.ACCEPTED]: "Đã xác nhận",
  [BOOKING_STATUS.DONE]: "Đã thanh toán",
  [BOOKING_STATUS.USER_CANCEL]: "Đã hủy",
  [BOOKING_STATUS.SHOP_CANCEL]: "Đã hủy",
  [BOOKING_STATUS.NOT_SHOW]: "Khách không đến",
};
const BookingStatus: React.FC<BookingStatusProps> = ({ status }) => {
  return <Badge type={status} label={statusLabel[status]} />;
};

export default BookingStatus;
